import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

// Types for Brand Pulse API responses
export type BrandSelectionResponse = {
    ok: boolean;
    data?: {
        suggested_brands?: Array<{
            name: string;
            domains: string[];
            competitor_paid_search_volume: string;
            region: string;
        }>;
        tracked_brands?: Array<{
            name: string;
            dbId: number;  // Database ID for deletion
            domains: string[];
            competitor_paid_search_volume: string;
            region: string;
        }>;
    };
    error?: string;
};

// Track brand response
export type TrackBrandResponse = {
    ok: boolean;
    data?: {
        id: number;
        brandName: string;
        brandDomain: string;
        country: string;
    };
    error?: string;
};

// Brand Pulse API
const leaderboard = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: "api.leaderboard",
    tagTypes: ["leaderboard"],
    endpoints: (builder) => ({
        getBrands: builder.query<
            any,
            { workspace_id: string; country: string; date: string, compareDate: string, industries: any }
        >({
            query: ({ workspace_id, country, date, compareDate, industries }) => ({
                url: `/leaderboard/brands`,
                method: "POST",
                body: JSON.stringify({ workspace_id, country, date, compareDate, industries }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }),
            providesTags: ["leaderboard"],
        }),
        getBrand: builder.query<
            any,
            { workspace_id: any, domain: string, region: string }
        >({
            query: ({ workspace_id, domain, region }) => ({
                url: `/leaderboard/brand`,
                method: "POST",
                body: JSON.stringify({ workspace_id, domain, region }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }),
            providesTags: ["leaderboard"],
        }),
        getCountries: builder.query<
            { countries: Array<{ region_name: string; share_of_searches: number }> },
            { workspace_id: string; devices?: string[]; platforms?: string[] }
        >({
            query: ({ workspace_id, devices = [], platforms = [] }) => ({
                url: `/leaderboard/countries`,
                method: "POST",
                body: JSON.stringify({
                    workspace: workspace_id,
                    devices,
                    platforms
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }),
            providesTags: ["leaderboard"],
        }),
        getIndustries: builder.query<{ domains: string[] }, { workspace_id: string, country: any }>({
            query: ({ workspace_id, country }) => ({
                url: `/leaderboard/industries`,
                method: "POST",
                body: JSON.stringify({ workspace_id: workspace_id, country: country }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }),
            providesTags: ["leaderboard"],
        }),
        getBrandLeaderboard: builder.query<
            any,
            { workspace_id: any, domain: string, region: string }
        >({
            query: ({ workspace_id, domain, region }) => ({
                url: `/leaderboard/brand`,
                method: "POST",
                body: JSON.stringify({ workspace_id, domain, region }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }),
            providesTags: ["leaderboard"],
        }),
    }),
});

export const {
    useGetBrandsQuery,
    useGetBrandQuery,
    useGetCountriesQuery,
    useGetIndustriesQuery,
    useGetBrandLeaderboardQuery
} = leaderboard;

export default leaderboard;


